import Button from '@storeblocks/button';
import { Illustration } from '@storeblocks/icon';
import React from 'react';
import { Link, useNavigate } from 'react-router';
import { getAppText } from 'Utils/text';
import { ButtonWrapper, Container } from './appError.styles';

interface AppErrorProps {
  readonly title: string;
  readonly description?: string;
  readonly action?: {
    label: string;
    onAction: () => void;
  };
  readonly withBackButton?: boolean;
}

export function AppError({
  title,
  description,
  action,
  withBackButton,
}: AppErrorProps): React.ReactElement {
  const navigate = useNavigate();

  return (
    <Container>
      <h1>{title}</h1>
      <Illustration name="something-went-wrong" />
      {description && <p>{description}</p>}

      <ButtonWrapper>
        {action ? (
          <Button onClick={action.onAction} m="8px">
            {action.label}
          </Button>
        ) : (
          <Button as={Link} m="8px" to="/">
            {getAppText('misc.error.appError.backToOverview')}
          </Button>
        )}
        {withBackButton && (
          <Button variant="outlined" m="8px" onClick={() => navigate(-1)}>
            {getAppText('misc.error.appError.back')}
          </Button>
        )}
      </ButtonWrapper>
    </Container>
  );
}
